module.exports = __webpack_public_path__ + "static/clonex-bdf7ec5346421426059a65896a7835d2.mp4";